import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { useEffect } from 'react'
import { useDirection } from './hooks/useDirection'
import Layout from './components/layout/Layout'
import Home from './pages/Home'
import Shop from './pages/Shop'
import ProductDetail from './pages/ProductDetail'
import About from './pages/About'
import Contact from './pages/Contact'
import Privacy from './pages/Privacy'
import Impressum from './pages/Impressum'
import Terms from './pages/Terms'
import Account from './pages/Account'
import Orders from './pages/Orders'
import Checkout from './pages/Checkout'

function App() {
  useDirection()

  useEffect(() => {
    // Always use dark mode
    document.documentElement.classList.add('dark')
  }, [])

  return (
    <div className="dark bg-dark-950 min-h-screen">
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/account" element={<Account />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/checkout" element={<Checkout />} />
        </Routes>
      </Layout>
      <Toaster 
        position="top-center"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#1a1d21',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '12px',
            direction: 'rtl',
          },
          success: {
            iconTheme: {
              primary: '#39ff14',
              secondary: '#1a1d21',
            },
            style: {
              border: '1px solid rgba(57, 255, 20, 0.3)',
            },
          },
          error: {
            iconTheme: {
              primary: '#ff006e',
              secondary: '#1a1d21',
            },
            style: {
              border: '1px solid rgba(255, 0, 110, 0.3)',
            },
          },
        }}
      />
    </div>
  )
}

export default App
